import React, { Component } from 'react';

class Feature2 extends Component {
    constructor(props){
        super(props);
        this.state = {
            features: [
                {
                    id: 1,
                    icon: 'bi bi-badge2',
                    title: 'Compromiso Comunitario',
                    text: 'Dedicación a servir a la comunidad, escuchando las necesidades de sus habitantes.'
                },
                {
                    id: 2,
                    icon: 'bi bi-badge2',
                    title: 'Transparencia',
                    text: 'Una gestión abierta y honesta de los fondos públicos, asegurando cada peso invertido en el desarrollo municipal.'
                },
                {
                    id: 3,
                    icon: 'bi bi-badge2',
                    title: 'Liderazgo Inclusivo',
                    text: 'Promoviendo la participación activa de todos los sectores de la sociedad en la toma de decisiones.'
                },
                {
                    id: 4,
                    icon: 'bi bi-badge2',
                    // Agregado: competencia clave del CV
                    title: 'Finanzas Públicas y Hacienda Municipal',
                    text: 'Más de 20 años gestionando presupuestos municipales, aplicando el presupuesto basado en resultados y la armonización contable.'
                },
                {
                    id: 5,
                    icon: 'bi bi-badge2',
                    // Agregado: competencia clave del CV
                    title: 'Fiscalización y Auditoría Gubernamental',
                    text: 'Experiencia en auditoría, control interno y cumplimiento normativo en los tres órdenes de gobierno.'
                }
            ]
        }
    }

    render() {
        return (
            <section className="feature-2 section-padding ">
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-lg-6">
                            <div className="section-heading center-heading text-center mb-60">
                                <h3 className="heading-title">Habilidades y Valores</h3>
                                <p>Construyendo Comunidad con Integridad y Liderazgo</p>
                            </div>
                        </div>
                    </div>
                    {/* gy-4 / gy-lg-5: separación vertical entre filas. justify-content-center: centra las dos tarjetas de la segunda fila en desktop. */}
                    <div className="row justify-content-center gy-4 gy-lg-5">
                        {
                            this.state.features.map((data,index) => (
                                <div className="col-lg-4 col-md-6" key={data.id}>
                                    <div className="feature-style-2 h-100">
                                        <i className={data.icon}></i>
                                        <div className="feature-text">
                                            <h4>{data.title}</h4>
                                            <p>{data.text}</p>
                                        </div>
                                    </div>
                                </div>
                            ))
                        }
                    </div>
                </div>
            </section> 
        );
    }
}

export default Feature2;
